import { render, staticRenderFns } from "./updateSetting.vue?vue&type=template&id=279b3145&lang=pug"
import script from "./updateSetting.vue?vue&type=script&lang=js"
export * from "./updateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports